module.exports = __webpack_public_path__ + "img/logo.75be4c65.png";